<template>
  <div class="base">
    <inside-header color="#fff" title="支付" />
    <div class="main">
      <div class="order-info">
        <div v-if="!loading" class="title">
          {{ info.service_pack.title }}
        </div>
        <div class="order-num">
          <span class="label">订单号：</span>
          <span class="num">{{ info.ordernum }}</span>
        </div>
        <van-divider />
        <div class="need-pay clear">
          <div class="pull-left">
            <span>应付：</span>
          </div>
          <div class="pull-right">
            <span class="prefix">￥</span>
            <span class="money">{{ info.amount }}</span>
          </div>
        </div>
      </div>
      <div v-if="info.pay_status === 'Unpaid'" class="pay-method">
        <van-radio-group v-model="nowPay">
          <van-cell-group>
            <van-cell class="item" title="支付宝" clickable @click="nowPay = 'aliWapPay'">
              <template #title>
                <span>
                  <a-icon type="alipay-circle" style="color: #3773f1" theme="filled" />
                </span>
                <span class="title">支付宝</span>
                <span class="recommend">推荐</span>
              </template>
              <template #right-icon>
                <van-radio name="aliWapPay" />
              </template>
            </van-cell>
            <van-cell class="item" title="微信" clickable @click="nowPay = 'wxWapPay'">
              <template #title>
                <span>
                  <a-icon type="wechat" style="color: #55b837" theme="filled" />
                </span>
                <span class="title">微信</span>
              </template>
              <template #right-icon>
                <van-radio name="wxWapPay" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
      <!-- 支付区域 -->
      <div id="payBody" ref="qrcode" class="show-pay-body" v-html="payBody">
        <!-- <div style="width: 128px;height: 128px;margin: auto" id="qrcode" ref="qrcode"></div> -->
      </div>
      <div v-if="info.pay_status === 'Unpaid'" class="pay-area">
        <a-button type="primary" :loading="state.paybtn" size="large" @click="paying">
          立即支付
        </a-button>
      </div>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'
import QRCode from 'qrcodejs2'

export default {
  name: 'TutorPay',
  components: {
    MainFooter,
    InsideHeader
  },
  props: {
    id: {}
  },
  data() {
    return {
      loading: true,
      state: {
        paybtn: false
      },
      info: {},
      payType: '',
      payBody: '',
      qrcode: null,
      nowPay: 'aliWapPay'
    }
  },
  created() {
    this.loadData(this.id, this.$route.query)
  },
  methods: {
    loadData(id, queryData) {
      this.loading = true
      this.$http({
        url: '/index/order/info',
        method: 'get',
        params: {
          id: id,
          queryData: queryData
        }
      }).then(res => {
        this.loading = false
        if (res.status === 'success') {
          const data = res.data
          this.info = data.info
          console.log(data)
        } else {
          this.$notification.error({
            message: '错误',
            description: res.message
          })
        }
      })
    },
    paying() {
      this.state.paybtn = true
      this.$http({
        url: '/index/order/pay',
        method: 'post',
        data: {
          ordernum: this.id,
          payment: this.nowPay
        }
      }).then(res => {
        this.state.paybtn = false
        if (res.status === 'success') {
          const data = res.data
          this.payType = data.type
          if (data.type === 'html') {
            this.payBody = data.body
            setTimeout(function () {
              const payForm = document.getElementById('payBody').querySelector('form')
              payForm.submit()
            }, 500)
          } else if (data.type === 'scan_url') {
            // 二维码模式
            this.bindQRCode(data.body)
            this.$notification.success({
              message: '成功',
              description: '请使用微信扫描二维码'
            })
            // 执行查询订单状态
            this.queryOrderStatus(this.id)
          } else if (data.type === 'jump_url') {
            // 跳转模式,微信H5方式返回
            window.location.href = data.body
          }
          console.log(data)
        } else {
          this.$notification.error({
            message: '错误',
            description: res.message
          })
        }
      })
    },
    queryOrderStatus(ordernum) {
      const that = this
      var cron = setInterval(function () {
        that.$http({
          url: '/index/order/status',
          method: 'get',
          params: {
            ordernum: ordernum
          }
        }).then(res => {
          if (res.data.pay_status === 'Paid') {
            clearInterval(cron)
            that.$notification.success({
              message: '成功',
              description: '订单支付成功'
            })
            that.loadData(ordernum)
          }
        })
      }, 3000)
    },
    bindQRCode(text) {
      var qrcode = new QRCode(this.$refs.qrcode, {
        text: text,
        width: 128,
        height: 128,
        colorDark: '#333', // 二维码颜色
        colorLight: '#ffffff', // 二维码背景色
        correctLevel: QRCode.CorrectLevel.H
      })
      this.qrcode = qrcode
    }
  }
}
</script>
<style lang="stylus" scoped>
  .base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
  }

  .main {
    padding: 15px;

    .order-info {
      padding: 15px;
      box-shadow:0 0 10px 0 rgba(216,216,216,0.3);
      overflow: hidden;

      .title {
        font-family: PingFang-SC-Bold;
        font-size: 15px;
        line-height: 16px;
        color: #333333;
        font-weight: bold;
      }

      .order-num {
        line-height: 28px;

        .label {
          font-family: PingFang-SC-Medium;
          font-size: 12px;
          line-height: 21px;
          color: #999999;
        }

        .num {
          font-family: PingFang-SC-Medium;
          font-size: 12px;
          color: #666666;
        }
      }

      .need-pay {
        margin-top: 10px;

        .pull-left {
          span {
            font-family: PingFang-SC-Medium;
            font-size: 14px;
            line-height: 32px;
            color: #999999;
          }
        }

        .pull-right {
          .prefix {
            font-family: PingFang-SC-Medium;
            font-size: 12px;
            line-height: 19px;
            color: #ff5c00;
          }

          .money {
            font-family: PingFang-SC-Medium;
            font-size: 21px;
            color: #ff5c00;
          }
        }
      }
    }

    .pay-method {
      padding: 30px 15px;
      box-shadow:0 0 10px 0 rgba(216,216,216,0.3);
      margin-top: 15px;

      .item {

        .title {
          margin-left: 5px;
          font-family: PingFang-SC-Medium;
          font-size: 16px;
          line-height: 14px;
          color: #333333;
        }

        .recommend {
          font-family: PingFang-SC-Regular;
          font-size: 12px;
          line-height: 19px;
          color: #ff5c00;

          margin-left: 5px;
        }
      }
    }

    .pay-area {
      button {
        border-radius: 10px;
        width: 100%;
        margin-top: 30px;
      }
    }
  }

</style>
